import React from 'react';

const RidesRecapModal = ({
  visible,
  onClose,
  onConfirm,
  title,
  selectionsByPark,
  formData,
}) => {
  if (!visible) return null;

  // Check if Park Completionist is selected
  const rideStrategies = formData?.attractionRideStrategy?.rideStrategy || [];
  const isParkCompletionist = rideStrategies.includes("Park Completionist – Ride everything possible");
  
  
  // Count total items
  const totalItems = Object.values(selectionsByPark).reduce((sum, items) => sum + items.length, 0);

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center p-4 bg-black/50">
      <div className="p-6 space-y-4 w-full max-w-2xl bg-white rounded-lg shadow-xl">
        <h2 className="text-xl font-bold text-gray-800">{title}</h2>

        {isParkCompletionist ? (
          <div className="space-y-4">
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
              <div className="flex items-center space-x-2">
                <h3 className="text-lg font-semibold text-blue-800">Park Completionist Mode Active</h3>
              </div>
              <p className="mt-2 text-sm text-blue-700">
                You've selected the <strong>Park Completionist</strong> strategy, which means ALL available rides from your selected parks have been automatically added to your must-ride list.
              </p>
              <p className="mt-1 text-sm text-blue-600">
                <strong>Total rides selected: {totalItems}</strong>
              </p>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-semibold text-gray-700">Rides by Park:</h4>
              <div className="overflow-y-auto space-y-3 max-h-64">
                {Object.entries(selectionsByPark || {}).map(([park, items]) => (
                  <div key={park} className="p-3 bg-gray-50 rounded-lg">
                    <h5 className="font-medium text-gray-700">{park}</h5>
                    <p className="text-sm text-gray-600">{items.length} rides selected</p>
                    <div className="flex flex-wrap gap-1 mt-2">
                      {items.slice(0, 5).map((item) => (
                        <span key={item} className="px-2 py-1 text-xs text-blue-700 bg-blue-100 rounded">
                          {item}
                        </span>
                      ))}
                      {items.length > 5 && (
                        <span className="px-2 py-1 text-xs text-gray-600 bg-gray-100 rounded">
                          +{items.length - 5} more
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
              <h3 className="text-lg font-semibold text-blue-800">Ride Selections Summary</h3>
              <p className="mt-2 text-sm text-blue-700">
                Here are the rides you've selected for your trip:
              </p>
              <p className="mt-1 text-sm text-blue-600">
                <strong>Total rides selected: {totalItems}</strong>
              </p>
            </div>
            
            <div className="space-y-3">
              <h4 className="font-semibold text-gray-700">Selected Rides by Park:</h4>
              <div className="overflow-y-auto space-y-3 max-h-64">
                {Object.entries(selectionsByPark || {}).map(([park, items]) => (
                  <div key={park} className="p-3 bg-gray-50 rounded-lg">
                    <h5 className="font-medium text-gray-700">{park}</h5>
                    <p className="text-sm text-gray-600">{items.length} rides selected</p>
                    <div className="flex flex-wrap gap-1 mt-2">
                      {items.map((item) => (
                        <span key={item} className="px-2 py-1 text-xs text-blue-700 bg-blue-100 rounded">
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="flex justify-end pt-4 space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md border border-gray-300 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Go Back, I Forgot One!
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md border border-transparent hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Looks Good!
          </button>
        </div>
      </div>
    </div>
  );
};

export default RidesRecapModal;
